export default __webpack_public_path__ + "static/therapy-m-e3514f6e312b41b537409cd8569ae743.svg";